/* eslint-disable react/jsx-no-bind */
// @flow
import * as React from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import { CompatRouter } from 'react-router-dom-v5-compat';

import history from 'common/middleware/history';

import AppContainer from './containers/AppContainer';
import {
    AppLoginContainer,
    AppChangePasswordContainer,
    ForgotPasswordContainer
} from 'platform/login';
import { withCapture404Route } from 'common/components/core/router';
import ErrorScreen from 'common/components/core/errors/ErrorScreen';

import { withErrorBoundary } from 'common/components/core/errors';
import { AuthProvider, SsoRedirectContainer } from 'common/modules/auth';

import { ResolvedClientIdProvider } from 'common/hooks/useResolvedClientId';

const Capture404Routes = withErrorBoundary()(withCapture404Route(ErrorScreen));

const AppRoutes = () => {
    return (
        <Switch>
            <Route exact path="/login" component={AppLoginContainer} />
            <Route exact path="/login/sso" component={SsoRedirectContainer} />
            <Route
                exact
                path="/changePassword"
                component={AppChangePasswordContainer}
            />
            <Route
                exact
                path="/forgotPassword"
                component={ForgotPasswordContainer}
            />
            <Route path="/" component={AppContainer} />
        </Switch>
    );
};

const Routes = (): React.Node => {
    const renderRoutes = () => {
        return (
            <ResolvedClientIdProvider>
                <AuthProvider>
                    <AppRoutes />
                </AuthProvider>
            </ResolvedClientIdProvider>
        );
    };

    return (
        <Router history={history}>
            <CompatRouter>
                <Capture404Routes>
                    <Route path="/" render={renderRoutes} />
                </Capture404Routes>
            </CompatRouter>
        </Router>
    );
};

export default Routes;
